import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react'
import AddInStorageModal from './AddInStorageModal'
import Api from '../../../../_helpers/Api'

//images
import docIcon from '../../../../assets/img/icons/document.png'
import closeIcon from '../../../../assets/img/icons/close.png'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import uploadImage from '@/assets/img/storage/icons/upload.svg'
import loader from '../../../../assets/img/loader.svg'
import Dropdown from '../../../partials/Dropdown'
import { trans } from '../../../../_providers/Translation'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { Checkbox, FormControlLabel } from '@mui/material'

let timeout

function AddOrEdit(props, ref) {
    const type = props.type || 1 // 1 - Част, 2 - Уред

    // State for dynamic storeload rows
    const [storeloadRows, setStoreloadRows] = useState([newStoreloadRow()])

    // State for AddInStorageModal
    const [addInStorageOpen, setAddInStorageOpen] = useState(false)
    const [addInStorageProduct, setAddInStorageProduct] = useState(null)
    const [addInStorageLoading, setAddInStorageLoading] = useState(false)
    const [addInStorageValidations, setAddInStorageValidations] = useState(null)

    // State for image upload
    const [image, setImage] = useState(null)

    const handleAttachImage = (e) => {
        const file = e.target.files[0]
        if (file) {
            setImage({
                file: file,
                tmppath: URL.createObjectURL(file)
            })
        }
    }

    const handleOpenImage = (e) => {
        e.preventDefault()
        document.getElementById('product-image').click()
    }

    // Handler to open AddInStorageModal
    const openAddInStorageModal = (product) => {
        setAddInStorageProduct(product)
        setAddInStorageValidations(null)
        setAddInStorageOpen(true)
    }

    // Handler to close AddInStorageModal
    const closeAddInStorageModal = () => {
        setAddInStorageOpen(false)
        setAddInStorageProduct(null)
        setAddInStorageLoading(false)
        setAddInStorageValidations(null)
    }

    // Handler for AddInStorageModal submit
    const handleAddInStorageSubmit = (e) => {
        e.preventDefault()
        setAddInStorageLoading(true)
        setAddInStorageValidations(null)
        const data = new FormData(e.target)
        // You may need to append product id or other info here
        if (addInStorageProduct && addInStorageProduct.id) {
            data.append('product_id', addInStorageProduct.id)
        }
        Api.post('storage/add-in-storage', data)
            .then(res => {
                setAddInStorageLoading(false)
                closeAddInStorageModal()
                if (typeof props.handleCreate === 'function') {
                    props.handleCreate(res.data)
                }
            })
            .catch(error => {
                setAddInStorageLoading(false)
                let _err = error.response
                if (_err && _err.status && _err.status == 422) {
                    let newValidations = {}
                    for (let [input, err] of Object.entries(_err.data.errors)) {
                        newValidations[input] = true
                    }
                    setAddInStorageValidations(newValidations)
                }
            })
    }

    // Template for a new storeload row
    function newStoreloadRow() {
        return {
            supplier_id: '',
            supplier: null,
            po_number: '',
            delivery_price: '',
            price: '',
            profit: '',
            quantity: '1',
            storage_location_id: '',
            storage: null,
            box: '',
            van_id: '',
            batch_number: '',
            comment: '',
        }
    }


    // Add a new storeload row
    const handleAddStoreloadRow = () => {
        setStoreloadRows(prev => [...prev, newStoreloadRow()])
    }

    // Delete a storeload row
    const handleDeleteStoreloadRow = (idx) => {
        setStoreloadRows(prev => prev.filter((_, i) => i !== idx))
    }

    // Handle changes in storeload row fields
    const handleStoreloadRowChange = (idx, name, value) => {
        setStoreloadRows(prev => prev.map((row, i) => {
            if (i !== idx) return row
            const updated = { ...row, [name]: value }
            if (name === 'delivery_price') {
                const sellPrice = Number(popup.data?.part?.sell_price)
                const deliveryPrice = Number(value)
                if (!isNaN(sellPrice) && !isNaN(deliveryPrice)) {
                    updated.profit = (sellPrice - deliveryPrice).toFixed(2)
                } else {
                    updated.profit = ''
                }
            }
            return updated
        }))
    }

    // Handle checkbox in storeload row
    const handleStoreloadRowCheckbox = (idx, name) => {
        setStoreloadRows(prev => prev.map((row, i) => i === idx ? { ...row, [name]: !row[name] } : row))
    }

    const auth = useAuthDataContext()

    const initialPopupData = {
        part: {
            category_id: null
        },
        profit: 0,
        position_id: 1,
        shouldSelectPosition: false,
        shouldSelectVan: false,
        shouldSelectShelveAndBox: false,
        shouldSelectInStock: false,
        shouldSelectStorage: false,
        can_modify_category: true,
    }

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        edit: false,
        editId: null,
        data: initialPopupData,
        key: 1,
        loading: false,
        stock: null,
    })

    const [vans, setVans] = useState([])
    const [positions, setPositions] = useState([])

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        add: stock => {
            let data = initialPopupData
            if (stock === 'van') {
                data.shouldSelectVan = true
            } else {
                data.shouldSelectShelveAndBox = true
                data.shouldSelectInStock = true
                data.shouldSelectStorage = true
            }
            setStoreloadRows([newStoreloadRow()])
            setPopup(prev => ({
                ...prev,
                edit: false,
                loading: false,
                data: data,
                stock,
                key: Math.random().toString()
            }))
            handleShow()
        },
        edit: (id) => {
            setPopup(prev => ({
                ...prev,
                edit: Math.random().toString(),
                editId: id,
                data: initialPopupData,
                loading: false
            }))
            handleShow()
        },
        hide: () => {
            handleHide()
        },
        openAddInStorageModal: openAddInStorageModal
    }))

    useEffect(() => {
        loadVans()
        loadPositions()
    }, [])

    useEffect(() => {
        console.log(popup.data)
    }, [popup.data])

    // при редакция извлича текущите данни, за да се попълнят полетата
    useEffect(() => {
        if (popup.edit) {
            Api.get(`storage/find-part?id=${popup.editId}`)
                .then(res => {
                    let data = res.data

                    // Fill storeloadRows from store_loads if present
                    if (Array.isArray(data.store_loads) && data.store_loads.length > 0) {
                        setStoreloadRows(
                            data.store_loads.map(load => ({
                                supplier_id: load.supplier_id || '',
                                supplier: load.supplier || null,
                                po_number: load.po_number || '',
                                delivery_price: load.delivery_price || '',
                                price: load.sell_price || '',
                                profit: load.profit || '',
                                quantity: load.quantity || '1',
                                storage_location_id: load.storage_location_id || '',
                                storage: load.storage || null,
                                box: load.box || '',
                                van_id: load.van_id || '',
                                batch_number: load.batch_number || '',
                                comment: load.comment || '',
                            }))
                        )
                    } else {
                        setStoreloadRows([])
                    }

                    if (res.data.office_stock) {
                        data.shouldSelectPosition = true
                    }

                    if (data.shouldSelectPosition) {
                        if (res.data.office_stock) {
                            data.shouldSelectShelveAndBox = true
                            data.shouldSelectInStock = true
                            data.shouldSelectStorage = true
                        } else if (res.data.van_stock) {
                            data.shouldSelectVan = true
                        }
                    }

                    // Ensure popup.data.part is populated for edit mode
                    setPopup(prev => ({
                        ...prev,
                        data: {
                            ...data,
                            part: {
                                ...data,
                                category: data.category || null,
                                number: data.number || '',
                                category_id: data.category_id || (data.category ? data.category.id : null),
                                sellable_online_price: data.sellable_online_price || '',
                            },
                        },
                    }))
                })
        }

    }, [popup.edit])

    useEffect(() => {
        let diff = Number(popup.data.price) - Number(popup.data.delivery_price)

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                profit: diff.toFixed(2)
            }
        }))

    }, [popup.data.delivery_price, popup.data.price])

    useEffect(() => {
        const sellPrice = Number(popup.data?.part?.sell_price)
        setStoreloadRows(prev => prev.map(row => {
            const deliveryPrice = Number(row.delivery_price)
            let profit = ''
            if (!isNaN(sellPrice) && !isNaN(deliveryPrice)) {
                profit = (sellPrice - deliveryPrice).toFixed(2)
            }
            return { ...row, profit }
        }))
    }, [popup.data?.part?.sell_price])

    const loadVans = () => {
        let url = 'vans/all?paginate=0'

        Api.get(url)
            .then(res => {
                setVans(res.data)
            })
    }

    const loadPositions = () => {
        let url = 'storage/positions'

        Api.get(url)
            .then(res => {
                setPositions(res.data)
            })
    }

    const handleShow = () => {
        setPopup(prev => ({
            ...prev,
            overlay: true
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        e.preventDefault()

        setValidations(null)

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false
            }))
            setImage(null)
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let url

        if (popup.edit) {
            url = 'storage/edit-product'
        } else {
            url = 'storage/add-product'
        }

        let data = new FormData(e.target)

        // при редакция - добавяме ID
        if (popup.edit) {
            data.append('id', popup.editId)
        }

        data.append('type', type)

        if (image && image.file) {
            data.append('image', image.file)
        }

        Api.post(url, data)
            .then(res => {

                if (popup.edit) {
                    if (typeof props.handleUpdate === 'function') {
                        props.handleUpdate(res.data)
                    }
                } else {
                    if (typeof props.handleCreate === 'function') {
                        props.handleCreate(res.data)
                    }
                }

                handleHide(e)
                setImage(null)

                document.getElementById("form").reset()

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {
                        setValidations(prevState => {
                            return { ...prevState, [input]: Array.isArray(err) ? err[0] : err }
                        })
                    }
                }

            })
    }

    const handleCategory = id => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                part: {
                    ...prev.data.part,
                    category_id: id
                }
            }
        }))
    }

    const handlePartChange = data => {
        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                part: {
                    ...prev.data.part,
                    ...data // merge all fields from the selected part
                }
            }
        }))
    }

    const handlePositionChange = e => {
        let val = Number(e.target.value)

        let selected = positions.filter(p => p.id === val)[0]
        let shouldSelectVan = selected.name === 'van'
        let shouldSelectShelveAndBox = selected.name === 'office'
        let shouldSelectInStock = selected.name === 'office'
        let shouldSelectStorage = selected.name === 'office'

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                position_id: val,
                shouldSelectVan: shouldSelectVan,
                shouldSelectShelveAndBox: shouldSelectShelveAndBox,
                shouldSelectInStock: shouldSelectInStock,
                shouldSelectStorage: shouldSelectStorage
            }
        }))
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }))
    }

    const handlePartInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                part: {
                    ...prev.data.part,
                    [name]: val
                }
            }
        }))
    }

    const handleCheckboxChange = e => {
        let name = e.target.name

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: !prev.data[name]
            }
        }))
    }


    const handleVanChange = e => {
        let val = e.target.value

        let van = vans.filter(v => Number(v.id) === Number(val))[0]

        if (van) {
            setPopup(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    van_id: van.id,
                    employee_id: van.employee_id
                }
            }))
        }

    }

    const handleStatusChange = id => {

        let statuses = props.statuses
        let status = statuses.filter(e => e.id === id)[0]
        let selected = popup.data.selectedStatuses

        if (status) {

            let exists = selected[id] ? true : false

            // ако е чекбокс
            if (status.checkbox) {
                if (exists) {
                    delete selected[id]
                } else {
                    selected[id] = 1
                }
            }
            // ако е радио
            else {
                statuses.filter(e => e.checkbox === 0 && e.id != id).map(e => {
                    if (selected[e.id]) {
                        delete selected[e.id]
                    }
                })

                if (exists) {
                    delete selected[id]
                } else {
                    selected[id] = 1
                }
            }

            // console.log(selected);

            setPopup(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    selectedStatuses: selected
                }
            }))
        }

    }

    const handleDeliveryPriceChange = e => {
        let deliveryPrice = e.target.value
        let price = null
        let profit = null

        let profitThreshold = getPartsPriceProfitThreshold()

        if (profitThreshold) {
            if (deliveryPrice < profitThreshold) {
                profit = getPartsPriceProfitBelowThreshold()
            } else if (deliveryPrice >= profitThreshold) {
                profit = getPartsPriceProfitAboveThreshold()
            }
        }

        if (profit) {
            price = calcPrice(deliveryPrice, profit)
        }

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                delivery_price: deliveryPrice,
                price: price !== null ? price : prev.data.price,
            }
        }))
    }

    const getPartsPriceProfitThreshold = () => {
        return auth.partner().settings.parts_price_profit_threshold
    }

    const getPartsPriceProfitBelowThreshold = () => {
        return auth.partner().settings.parts_price_profit_below_threshold
    }

    const getPartsPriceProfitAboveThreshold = () => {
        return auth.partner().settings.parts_price_profit_above_threshold
    }

    const calcPrice = (price, profit) => {
        return (Number(price) + ((Number(profit) * Number(price)) / 100)).toFixed(2)
    }

    return (
        <>
            <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
                <form id="form" className={`${popup.modal ? 'show' : ''} popup-primary large`} autoComplete="off" onSubmit={handleSave}>
                    <div className='head-new'>
                        <img src={popupDefaultHeadImage} alt="icon" />
                        <div className='texts'>
                            <h2>
                                {popup.edit ?
                                    type === 1 ? trans('headings.editPart') : trans("headings.editAppliance") :
                                    type === 1 ? trans('headings.addPart') : trans("headings.addAppliance")
                                }
                            </h2>
                            <p>
                                lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </p>
                        </div>
                        <span className='close' onClick={handleHide}>

                        </span>
                    </div>
                    {/* Top fields: category, name, number, image, description */}
                    <div className="row">
                        <div className="col">
                            <label htmlFor="category_id">{trans('labels.category')}</label>
                            <Dropdown
                                key={popup.key}
                                inputName="category"
                                inputIdName="category_id"
                                inputValue={
                                    popup.data && popup.data.part && popup.data.part.category && popup.data.part.category.name
                                        ? popup.data.part.category.name
                                        : (popup.data && popup.data.part ? popup.data.part.category_id : '')
                                }
                                inputIdValue={popup.data && popup.data.part ? popup.data.part.category_id : ''}
                                inputClassName={validations && validations.category_id ? 'validate' : ''}
                                url="partners/categories/all"
                                renderText={data => data.name}
                                onChange={data => handleCategory(data.id)}
                                inputDisabled={popup.data && !popup.data.can_modify_category}
                            />
                        </div>
                        <div className="col">
                            <label>{trans('labels.name')}</label>
                            <Dropdown
                                key={popup.key}
                                inputName="name"
                                inputIdName="part_id"
                                inputValue={popup.data ? popup.data.name : ''}
                                inputIdValue={popup.data && popup.data.part_id ? popup.data.part_id : ''}
                                inputClassName={validations && validations.name ? 'validate' : ''}
                                inputPlaceholder="Търсене по име или номер"
                                url="parts/search"
                                params={{ category_id: popup.data?.part?.category_id }}
                                requiredParams={['category_id']}
                                loadDataOnFocus={true}
                                renderInputText={data => data.name}
                                renderText={data => <div>{data.name} <br /> <span style={{ fontSize: '10px' }}>{data.number}</span></div>}
                                onChange={handlePartChange}
                            />
                        </div>
                        <div className="col">
                            <label>{trans('labels.number')}</label>
                            <input
                                type="text"
                                name="number"
                                className={validations && validations.number ? 'validate' : ''}
                                value={popup.data && popup.data.part && popup.data.part.number ? popup.data.part.number : ''}
                                onChange={handlePartInputChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.brand')}</label>
                            <input
                                type="text"
                                name="brand"
                                className={validations && validations.brand ? 'validate' : ''}
                                value={popup.data && popup.data.part && popup.data.part.brand ? popup.data.part.brand : ''}
                                onChange={handlePartInputChange}
                            />
                        </div>

                        <div className="col">
                            <label>{trans('labels.model')}</label>
                            <input
                                type="text"
                                name="model"
                                className={validations && validations.model ? 'validate' : ''}
                                value={popup.data && popup.data.part && popup.data.part.model ? popup.data.part.model : ''}
                                onChange={handlePartInputChange}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col">
                            <label>{trans('labels.selling_price')}</label>
                            <input
                                type="number"
                                name="sell_price"
                                className={validations && validations.sell_price ? 'validate' : ''}
                                value={popup.data && popup.data.part && popup.data.part.sell_price ? popup.data.part.sell_price : ''}
                                onChange={handlePartInputChange}
                            />
                        </div>

                        <div className="col">
                            <label>{trans("labels.minQuantity")}</label>
                            <input
                                type="text"
                                name="min_quality"
                                className={
                                    validations && validations.min_quality ? "validate" : ""
                                }
                                value={
                                    popup.data && popup.data.part && popup.data.part.min_quality
                                        ? popup.data.part.min_quality
                                        : ""
                                }
                                onChange={handlePartInputChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.image')}</label>
                            <div className='upload-logo'>
                                {image && image.tmppath ? (
                                    <img
                                        src={image.tmppath}
                                        className='uploaded-image'
                                        alt="preview"
                                        style={{ maxHeight: '150px' }}
                                    />
                                ) : popup.data?.picture ? (
                                    <img
                                        src={popup.data?.picture}
                                        className='uploaded-image'
                                        style={{ maxHeight: '150px' }}
                                        alt="product"
                                    />
                                ) : (
                                    <div className='initial-look'>
                                        <img src={uploadImage} alt="upload" />
                                        <b>{trans('buttons.attachPhoto')}</b>
                                        <p>PNG, JPG, GIF</p>
                                    </div>
                                )}
                                <div>
                                    <input
                                        id='product-image'
                                        type="file"
                                        onChange={handleAttachImage}
                                        accept="image/*"
                                        name='image'
                                        hidden
                                    />
                                    <button
                                        className={`button-add button-small ${image || popup.data?.picture ? '' : 'no-logo'}`}
                                        onClick={handleOpenImage}
                                    >
                                        {trans('buttons.attachOtherPhoto')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <label>{trans('labels.description')}</label>
                            <textarea
                                name="description"
                                className={validations && validations.description ? 'validate' : ''}
                                value={popup.data && popup.data.description ? popup.data.description : ''}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <hr />

                    <div className='row'>
                        <div
                            className='col no-margin-on-mobile'
                        >
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="is_sellable_online"
                                        value="1"
                                        checked={popup.data && popup.data.is_sellable_online ? true : false}
                                        onChange={handleCheckboxChange}
                                        size='small'
                                    />
                                }
                                label={trans('random.isSellableOnline')}
                            />
                        </div>
                    </div>

                    {/* Show sellable_online_price field only if is_sellable_online is checked */}
                    {popup.data && popup.data.is_sellable_online && (
                        <div
                            className="row"
                            style={{
                                marginTop: "-10px"
                            }}
                        >
                            <div className="col">
                                <label>{trans('labels.sellable_online_price_if_different')}</label>
                                <input
                                    type="number"
                                    name="sellable_online_price"
                                    min="0"
                                    step="0.01"
                                    className={validations && validations.sellable_online_price ? 'validate' : ''}
                                    value={popup.data.sellable_online_price || ''}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    )}
                    {(!popup.edit) && (
                        <>
                            <hr />
                            <div className='row'>
                                <div className='col no-margin-on-mobile'>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="in_stock"
                                                value="1"
                                                checked={popup.data && popup.data.in_stock ? true : false}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                        }
                                        label={trans('random.inStockSec')}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                    {/* Show storeload rows only if in_stock is checked and not in edit mode (add mode only) */}
                    {(!popup.edit && popup.data && popup.data.in_stock) && (
                        <div
                            className='row'
                            style={{
                                marginTop: "-10px"
                            }}
                        >
                            <div className='col'>
                                {storeloadRows.map((row, idx) => (
                                    <div
                                        key={`${popup.key}-${idx}`}
                                        className='pannel'
                                    >
                                        <div className="row">
                                            <div className="col">
                                                <label>{trans('labels.supplier')}</label>
                                                <Dropdown
                                                    inputName={`storeload[${idx}][supplier]`}
                                                    inputIdName={`storeload[${idx}][supplier_id]`}
                                                    inputValue={row.supplier ? row.supplier.name : ''}
                                                    inputIdValue={row.supplier_id}
                                                    url="suppliers/all"
                                                    renderText={data => data.name}
                                                    onChange={data => handleStoreloadRowChange(idx, 'supplier_id', data.id)}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>{trans('labels.factureOfSupplier')}</label>
                                                <input
                                                    type="text"
                                                    name={`storeload[${idx}][po_number]`}
                                                    value={row.po_number}
                                                    onChange={e => handleStoreloadRowChange(idx, 'po_number', e.target.value)}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>{trans('labels.deliveryPrice')}</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    name={`storeload[${idx}][delivery_price]`}
                                                    value={row.delivery_price}
                                                    onChange={e => handleStoreloadRowChange(idx, 'delivery_price', e.target.value)}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>{trans('labels.salePrice')}</label>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    step="0.01"
                                                    name={`storeload[${idx}][price]`}
                                                    value={
                                                        popup.edit
                                                            ? row.price
                                                            : (popup.data && popup.data.part && popup.data.part.sell_price ? popup.data.part.sell_price : row.price)
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <label>{trans('labels.profit')}</label>
                                                <input
                                                    type="number"
                                                    name={`storeload[${idx}][profit]`}
                                                    value={row.profit}
                                                    disabled
                                                />
                                            </div>
                                            <div className="col">
                                                <label>{trans('labels.quantity')}</label>
                                                <input
                                                    type="number"
                                                    min="1"
                                                    step="1"
                                                    name={`storeload[${idx}][quantity]`}
                                                    value={row.quantity}
                                                    onChange={e => handleStoreloadRowChange(idx, 'quantity', e.target.value)}
                                                />
                                            </div>
                                            {popup.stock === 'van' ?
                                                <div className="col">
                                                    <label>{trans('labels.van')}</label>
                                                    <Dropdown
                                                        inputName={`storeload[${idx}][storage]`}
                                                        inputIdName={`storeload[${idx}][storage_location_id]`}
                                                        inputValue={row.storage ? row.storage.reg_no : ''}
                                                        inputIdValue={row.storage_location_id}
                                                        url="vans/all"
                                                        renderText={data => data.reg_no}
                                                        onChange={data => handleStoreloadRowChange(idx, 'storage_location_id', data.id)}
                                                    />
                                                    {validations && validations['storage_location_id'] &&
                                                        <p style={{ color: '#e470a4', fontSize: '12px', margin: '2px 0 0' }}>
                                                            {trans('messages.required')}
                                                        </p>
                                                    }
                                                </div>
                                                :
                                                <div className="col">
                                                    <label>{trans('labels.storage')}</label>
                                                    <Dropdown
                                                        inputName={`storeload[${idx}][storage]`}
                                                        inputIdName={`storeload[${idx}][storage_location_id]`}
                                                        inputValue={row.storage ? row.storage.name : ''}
                                                        inputIdValue={row.storage_location_id}
                                                        url="storages/all"
                                                        renderText={data => data.name}
                                                        onChange={data => handleStoreloadRowChange(idx, 'storage_location_id', data.id)}
                                                    />
                                                    {validations && validations['storage_location_id'] &&
                                                        <p style={{ color: '#e470a4', fontSize: '12px', margin: '2px 0 0' }}>
                                                            {trans('messages.required')}
                                                        </p>
                                                    }
                                                </div>
                                            }
                                            <div className="col">
                                                <label>{trans('labels.box')}</label>
                                                <input
                                                    type="text"
                                                    name={`storeload[${idx}][box]`}
                                                    value={row.box}
                                                    onChange={e => handleStoreloadRowChange(idx, 'box', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <label>{trans('labels.batch')}</label>
                                                <input
                                                    type="text"
                                                    name={`storeload[${idx}][batch_number]`}
                                                    value={row.batch_number}
                                                    onChange={e => handleStoreloadRowChange(idx, 'batch_number', e.target.value)}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>{trans('labels.comments')}</label>
                                                <input
                                                    type="text"
                                                    name={`storeload[${idx}][comment]`}
                                                    value={row.comment}
                                                    onChange={e => handleStoreloadRowChange(idx, 'comment', e.target.value)}
                                                />
                                            </div>
                                            <div className="col">
                                                <label>{trans('labels.reason')}</label>
                                                <select
                                                    name={`storeload[${idx}][reason]`}
                                                    value="load"
                                                    onChange={e => handleStoreloadRowChange(idx, 'reason', e.target.value)}
                                                >
                                                    <option value="load">{trans('random.load') || 'Supplier Delivery'}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <hr />
                                        <button type="button" disabled={storeloadRows.length <= 1} className="button button-remove button-small" onClick={() => handleDeleteStoreloadRow(idx)}>
                                            {trans('buttons.delete') || 'Delete'}
                                        </button>
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="button button-add"
                                    onClick={handleAddStoreloadRow}
                                    style={{
                                        width: "fit-content"
                                    }}
                                >
                                    {trans('buttons.addStoreloadRow') || 'Add Storeload Row'}
                                </button>
                            </div>
                        </div>
                    )}



                    <div className="footer align-right">
                        {popup.loading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <button className="button" onClick={handleHide}>
                                    {trans('buttons.cancel')}
                                </button>
                                <button className="button button-primary" type="submit">
                                    {trans('buttons.save')}
                                </button>
                            </>
                        }
                    </div>
                </form>
            </div >
            {/* AddInStorageModal integration */}
            <AddInStorageModal
                open={addInStorageOpen}
                onClose={closeAddInStorageModal}
                product={addInStorageProduct}
                onSubmit={handleAddInStorageSubmit}
                loading={addInStorageLoading}
                validations={addInStorageValidations}
            />
        </>
    )
}

export default forwardRef(AddOrEdit)